const { Heading } = require('@chakra-ui/react');

const Team = () => {
  return <Heading p="10vh">Team</Heading>;
};

export default Team;
